// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stakeAndDistribution .btns {\n  background: #fff; }\n", "",{"version":3,"sources":["webpack://./src/app/pages/StakeAndDistribution/components/Top/style.scss"],"names":[],"mappings":"AACA;EAEI,gBAAgB,EAAA","sourcesContent":["@import \"styles/_vars.scss\";\n.stakeAndDistribution {\n  .btns {\n    background: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
